import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  typesdiFromES:"",
  typesdiToES:"",
  typesdiFromEN:"",
  typesdiToEN:"",
  isFinished:false, 
  isScanned:true,
  isPending:true,
  notIsScanned:true,
  preiddocSheetFrom:"",
  preiddocSheetTo:"",
  sufiddocSheetFrom:"",
  sufiddocSheetTo:"",
  numberDTFrom:"",
  numberDTTo:"",
  dateSheetFrom:null,
  dateSheetTo:null,  
  rel_trans_store_idFrom:"",
  rel_trans_store_idTo:"",
  ori_tras_store_idFrom: "", 
  ori_tras_store_idTo: "", 
  vehicleFrom:"",
  vehicleTo:"",
  acceptFROM:"",
  acceptTO:""
};

const filtersFormDISlice = createSlice({
  name: 'filtersFormDI',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersFormDISlice.actions;
export default filtersFormDISlice.reducer;
